import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { GALLERY } from "@/data/site";
import { SectionHeader } from "@/components/SectionHeader";
import { Stagger, Item } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

export const GalleryStrip = () => {
  const { t } = useLang();
  const g = t.galleryStrip;
  const items = GALLERY.filter((x) => x.cat !== "Fleet").slice(0, 8);
  return (
  <section className="bg-[var(--canvas-2)] py-24 lg:py-32" data-testid="gallery-strip-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeader eyebrow={g.eyebrow} title={g.title} text={g.text} />
        <Link to="/gallery" className="btn-ghost w-fit" data-testid="gallery-strip-view-all">
          {g.cta} <ArrowUpRight size={16} />
        </Link>
      </div>
      <Stagger className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4" stagger={0.08}>
        {items.map((g, i) => (
          <Item key={g.title} className={`img-zoom overflow-hidden rounded-2xl ${i % 4 === 1 || i % 4 === 2 ? "md:mt-10" : ""}`}>
            <Link to="/gallery" data-testid={`gallery-strip-item-${i}`} className="block">
              <img src={g.src} alt={g.title} className="aspect-[4/5] w-full object-cover" loading="lazy" />
            </Link>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
  );
};
